import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BasePlate } from '../components/base-plate/Component.js';

var styles = {"bold":"plate__bold_1fjzq","description":"plate__description_1fjzq","footer":"plate__footer_1fjzq","rounded":"plate__rounded_1fjzq","shadow":"plate__shadow_1fjzq"};
require('./mobile.css')

var PlateMobile = forwardRef(function (restProps, ref) { return (React.createElement(BasePlate, __assign({}, restProps, { styles: styles, ref: ref }))); });

export { PlateMobile };
